import React from 'react';
import { useVisibleApps, type VisibleApp } from '../hooks/use-visible-apps';
import { NoAppsAvailablePage } from '../components/NoAppsAvailablePage';

type AppAccessGateProps = {
	appName: VisibleApp['name'];
	children: React.ReactNode;
};

export const AppAccessGate = ({
	appName,
	children,
}: AppAccessGateProps): React.JSX.Element | null => {
	const { apps, loading } = useVisibleApps();
	const hasAccess = apps.some((app) => app.name === appName);

	if (loading) {
		return null;
	}

	if (!hasAccess) {
		return <NoAppsAvailablePage />;
	}

	return <>{children}</>;
};
